import {
  Component,
  HostListener,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { SlickCarouselComponent } from 'ngx-slick-carousel';

import AppValues from 'src/app/common/app.values';
import { SocialInitiative } from 'src/app/common/custom.types';
import { Repeat } from 'src/app/utils';
import { CardType } from '../cards/cards.types';
import { Layouts } from './carousel.enum';

// https://kenwheeler.github.io/slick/#settings
export interface SlickBreakpoint {
  breakpoint: number;
  settings: BreakpointSettings;
}

interface BreakpointSettings {
  slidesToShow: number;
  centerMode: boolean;
  centerPadding: string;
}
export interface SlickConfig {
  slidesToShow: number;
  slidesToScroll: number;
  breakpoints: Repeat<1, SlickBreakpoint>;
}

interface SlideConfig {
  desktopSlidesToShow: number;
  mobileBreakpoint: number;
  mobileSlidesToShow: number;
}

@Component({
  selector: 'app-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CarouselComponent implements OnInit, OnChanges {
  @Input({ required: true }) public data: SocialInitiative[];
  @Input({ required: true }) public type: CardType;
  @Input({ required: true }) public title: string;

  @ViewChild(SlickCarouselComponent, { static: false }) public slickCarouselComponent: SlickCarouselComponent;

  public cardType: string;

  public readonly DIGITS_REPRESENTATION_OPTIONS: string = AppValues.DIGITS_REPRESENTATION_OPTIONS;
  /**
   * Configures number of slides to be shown for desktop and mobile modes.
   */
  public responsiveConfig: SlideConfig = {
    mobileBreakpoint: 700,
    desktopSlidesToShow: 2,
    mobileSlidesToShow: 1,
  };

  public showButton: boolean;
  public currentLayout: string;

  public slideConfig: SlickConfig = {
    slidesToShow: 2,
    slidesToScroll: 1,
    breakpoints: [
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '40px',
        },
      },
    ],
  };

  /**
   * @description Listens to the window width in order to
   * update showButton flag according to the config.
   * @param { number } windowWidth
   */
  @HostListener('window:resize', ['$event.target.innerWidth'])
  public onResize(windowWidth: number): void {
    this.currentLayout = windowWidth > this.slideConfig.breakpoints[0].breakpoint ? Layouts.DESKTOP : Layouts.MOBILE;
    this.showButton = this.data.length > this.slideConfig.slidesToShow;

    if (this.currentLayout === Layouts.MOBILE) {
      this.showButton = false;
    }
  }

  public ngOnInit(): void {
    this.onResize(window.innerWidth);
    this.cardType = this.type;
  }

  /**
   * @description manually updates dynamically changed slides during navigation
   * within the same component without unmounting it.
   * @param { SimpleChanges } simpleChanges
   */
  public ngOnChanges(simpleChanges: SimpleChanges): void {
    if (!simpleChanges['data']?.firstChange) {
      this.onResize(window.innerWidth);
    }
  }

  public get layoutsResult(): typeof Layouts {
    return Layouts;
  }
}
